import styled from 'styled-components'

export const HelperButton = styled.button`
  font-size: 1em;
  font-weight: 700;
  color: #3D6666;
  text-decoration: underline #3D6666;
  cursor: pointer;
  background: inherit;
  border: none;
`

export const Link = styled.a`
  font-size: 1em;
  font-weight: 700;
  color: #3D6666;
  text-decoration: underline #3D6666;
  cursor: pointer;
`

export const DefaultTitle = styled.h1`
  font-family: 'Tiempos', serif;
  font-size: 1.9rem;
  line-height: 2.8rem;
  margin-bottom: 0.5rem;

  @media only screen and (max-width: 640px) {
    line-height: 2rem;
  }
`

export const DefaultBigTitle = styled.h1`
  font-family: 'Tiempos', serif;
  font-size: 2.5em;
  line-height: 1.5em;
  margin-bottom: 0.5em;

  @media only screen and (max-width: 640px) {
    line-height: 1.5em;
  }
`

export const DefaultSubtitle = styled.h6`
  font-family: 'Avenir', serif;
  font-size: 1.1em;
  line-height: 24px;
  color: #65666A;
  margin-bottom: 48px;

  @media only screen and (max-width: 540px) {
    & br {
      display: none;
    }
  }
`

export const DefaultBigSubtitle = styled.h6`
  font-family: 'Avenir', serif;
  font-size: 1.4em;
  line-height: 1.5em;
  color: #65666A;
  margin-bottom: 48px;

  @media only screen and (max-width: 540px) {
    & br {
      display: none;
    }
  }
`

export const ApplicationBodyContainer = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
`

export const ApplicationBodyContent = styled.div<{ width?: string }>`
  width: ${props => props.width ?? '70%'};
  display: flex;
  flex: 1;
  flex-direction: column;

  @media only screen and (max-width: 640px) {
    width: 100vw;
    padding: 0 24px;
  }
`

export const ApplicationBodyFooter = styled.div<{ marginTop?: string }>`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-top: 1px solid #C8C8C8;
  padding: 20px;
  margin-top: ${props => props.marginTop ?? '160px'};

  @media only screen and (max-width: 640px) {
    width: 90%;
    padding: 20px 10px;
    margin-top: 80px;
    flex-direction: column;

    button {
      width: 100%;
    }
  }
`

export const RadioButtonsContainer = styled.div`
  display: flex;
  gap: 80px;

  @media only screen and (max-width: 820px) {
    gap: 20px;
  }
`

export const ApplicationMethodPDFReminderContainer = styled.div`
  max-width: 560px;
  margin-top: 64px;
`

export const FormContainer = styled.div<{ maxWidth?: string, maxHeight?: string }>`
  width: 100%;
  max-width: ${props => props.maxWidth ?? '480px'};
  max-height: ${props => props.maxHeight ?? '100%'};
  display: flex;
  flex-direction: column;
  gap: 32px;
  overflow-y: auto;
  -ms-overflow-style: none;
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }
`

export const BeforeStartInstructionsContainer = styled.div`
  max-width: 686px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  color: #353744;

  & > span {
    margin-bottom: 28px;
    margin-top: 64px;
    font-weight: 800;
  }
`

export const BeforeStartInstruction = styled.div`
  padding: 16px 24px;
  width: 100%;
  border: 1px solid #C8C8C8;
  background: #fff;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  display: flex;
  gap: 8px;
  align-items: center;

  & svg {
    color: #3D6666;
    fill: #F5F9F9;
    height: 20px;
    width: 20px;
    min-width: 20px;
  }
`

export const PDFApplicationCard = styled.div`
  width: 100%;
  background: #fff;
  border: 1px solid #C8C8C8;
  color: #65666A;
  font-weight: 800;
  font-size: 18px;
  line-height: 24px;
  padding: 24px 32px;
  display: flex;
  flex-direction: column;
  gap: 24px;
`

export const ApplicationNextButtonsContainer = styled.div`
  display: flex;
  gap: 16px;

  @media only screen and (max-width: 640px) {
    align-items: center;
    flex-direction: column;
  }
`

export const FormItemContainer = styled.div<{ maxWidth?: string }>`
  width: 100%;
  max-width: ${props => props.maxWidth ?? '440px'};
  display: flex;

  & + & {
    margin-top: 100px;
  }
`

export const AreasOfPracticeCheckboxContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
`

export const AreasOfPracticeCheckboxItem = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
`

export const SubAreasOfPracticeContainer = styled.div`
  width: 100%;
  max-width: 500px;
  display: flex;
  gap: 20px;

  & .subareas-container {
    display: flex;
    flex-direction: column;
    padding: 4px 0 8px;
    gap: 16px;
    width: 100%;
  }

  & .subarea-title {
    font-weight: 900;
    font-size: 14px;
    line-height: 21px;
  }

  & .radio-options {
    display: flex;
    gap: 30px;
  }
`

export const PercentageContainer = styled.div`
  display: grid;
  grid-template-columns: 3fr 1fr;
  gap: 32px;

  @media only screen and (max-width: 640px) {
    grid-template-columns: 1fr;
  }
`

export const PercentageItemsContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 24px;
`

export const PercentageItem = styled.div`
  width: 100%;
  border: 1px solid #C8C8C8;
  background: #fff;
  padding: 22px 32px 32px 24px;
  display: flex;
  flex-direction: column;
  position: relative;

  & > h6 {
    font-weight: 900;
    font-size: 16px;
    line-height: 24px;
    color: #65666A;
    margin-bottom: 24px;
  }

  & > span {
    font-weight: 800;
    font-size: 12px;
    line-height: 18px;
    color: #7B7C82;
  }

  & .slider-input-container {
    width: 100%;
    display: grid;
    grid-template-columns: 1fr 90px;
    gap: 20px;
    align-items: center;
    padding-left: 12px;
    margin-top: 6px;

    @media only screen and (max-width: 640px) {
      grid-template-columns: 1fr 70px;
    }
  }
`

export const PercentageTotal = styled.div<{ isValid: boolean }>`
  width: 100%;
  height: 100%;

  & > div {
    top: 270px;
    position: sticky;
    width: 100%;
    border: 1px solid #C8C8C8;
    background: #fff;
    padding: 16px 24px;
  }

  & > div h4 {
    font-family: Tiempos;
    font-weight: 800;
    font-size: 20px;
    line-height: 27px;
    color: #353744;
  }

  & > div span {
    font-weight: 400;
    font-size: 14px;
    line-height: 21px;
    color: #7B7C82;
  }

  & > div h1 {
    font-family: Tiempos;
    font-weight: 800;
    font-size: 36px;
    line-height: 57px;
    color: ${props => props.isValid ? '#3D6666' : '#E84242'};
  }

  & .error-container {
    display: flex;
    align-items: center;
    margin-top: 10px;
    margin-bottom: 5px;
  }

  & .error-container span {
    font-weight: 800;
    font-size: 16px;
    line-height: 18px;
    color: #E84242;
  }

  & .error-container svg {
    fill: #E84242;
    min-width: 18px;
    min-height: 18px;
    margin-right: 6px;
  }
`

export const ApplicationContentWithLeftStickyBox = styled.div<{ width?: string, top?: number }>`
  width: ${props => props.width ?? '70%'};
  display: grid;
  grid-template-columns: 240px auto;
  gap: 80px;

  .sticky-box {
    top: ${props => props.top ?? 136}px;
    position: sticky;
    width: 100%;
    border: 1px solid #C8C8C8;
    background: #fff;
    padding: 16px 14px;
    height: fit-content;
    display: flex;
    flex-direction: column;

    h1 {
      font-size: 20px;
      line-height: 24px;
      margin: 0 0 11px 10px;
      font-family: Tiempos, sans-serif;
    }

    hr {
      margin-bottom: 20px;
      border: 0.5px solid #C8C8C8;
    }

    span {
      font-weight: 400;
      font-size: 14px;
      line-height: 21px;
      color: #7B7C82;
      margin-left: 10px;
    }
    
    span + span {
      margin-top: 16px;
    }
    
    .highlighted {
      font-weight: 900;
      color: #3D6666;
    }
  }

  .right-content {
    display: flex;
    flex-direction: column;
    gap: 190px;
  }

  @media only screen and (max-width: 640px) {
    width: 100vw;
    padding: 0 24px;
    gap: 20px;
  }
`

export const AboutAttorneyContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;

  & h1 {
    font-size: 30px;
    line-height: 45px;
    margin-bottom: 0;
  }

  & .has-resume {
    display: flex;
    align-items: center;

    & h6 {
      font-weight: 400;
      font-size: 14px;
      line-height: 21px;
    }

    & div {
      min-height: 16px;
      min-width: 16px;
      max-height: 16px;
      max-width: 16px;
      margin: 0 6px 0 0;
    }
  }

  &.not-focused {
    opacity: 0.5;
  }
`

export const AboutAttorneyFormContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  gap: 24px;
  margin-top: 32px;

  & div.form-container {
    width: 100%;
    max-width: 440px;
    height: 100%;
    display: flex;
    flex-direction: column;
    gap: 24px;

    & h6 {
      font-weight: 900;
      font-size: 14px;
      line-height: 21px;
      color: #7B7C82;
      margin-bottom: -8px;
    }

    & button {
      max-width: 200px;
    }

    & div.form-title {
      display: flex;
      gap: 8px;
      align-items: center;

      & div {
        margin: 0;
        display: none;
      }

      & button {
        background: transparent;
        padding: 0;
        margin: 0 0 0 auto;
        border: none;
        display: none;

        & svg {
          height: 20px;
          width: 20px;
        }
      }
    }
  }

  & div.form-content {
    width: 100%;
    max-width: 440px;
    height: 100%;
    display: flex;
    flex-direction: column;
    gap: 24px;
  }

  & .accordion-closed {
    background: #fff;
    border: 1px solid #C8C8C8;
    padding: 16px;

    & div.form-title {
      & h6 {
        margin-bottom: 0;
      }
      
      & div {
        display: flex !important;
      }

      & button {
        display: flex !important;
        align-items: center;
        justify-content: center;
      }
    }

    & div.form-content {
      display: none;
    }
  }

  & .accordion-open {
    & div.form-title {
      padding-right: 16px;
    }

    & div.form-title button {
      display: flex !important;
      align-items: center;
      justify-content: center;
    }
  }
`

export const RenewVerifyItemContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  gap: 24px;
  margin-top: 32px;

& div.form-container {
    width: 100%;
    max-width: 440px;
    height: 100%;
    display: flex;
    flex-direction: column;
    gap: 24px;
  }
`

export const AttorneyWorkHistoryWithoutResume = styled.div`
  width: 100%;
  max-width: 400px;
  height: 100%;
  display: flex;
  flex-direction: column;

  p {
    font-weight: 500;
    font-size: 14px;
    line-height: 21px;
    color: #353744;
  }

  strong {
    color: #0F172A;
    font-weight: 700;
    font-size: 14px;
    line-height: 21px;
  }

  button {
    max-width: 350px !important;
  }

  div.former-employer-section {
    width: 100%;
    height: 100%;
    display: flex;
    gap: 20px;
    margin: 26px 0 10px;
  }

  div.former-employer-form {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    gap: 40px;
  }

  div.former-employer-dates-container {
    width: 100%;
    height: 100%;
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 38px;
  }
`
export const OptionButtonsContainer = styled.div<{ labelSize?: 'big' | 'medium' }>`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;

  & div {
    display: flex;
    gap: 12px;
  }

  span {
    font-weight: 900;
    color: #353744;
    font-weight: 900; 
    font-size: ${props => props.labelSize === 'big' ? '24px' : props.labelSize === 'medium' ? '18px' : '14px'};
    line-height: ${props => props.labelSize === 'big' ? '34px' : props.labelSize === 'medium' ? '26px' : '21px'};
    margin-bottom: 16px;
  }
`

export const PolicyTypeContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 10px 42px 10px 10px;

  @media only screen and (max-width: 640px) {
    padding: 10px;
  }

  h5 {
    font-weight: 900;
    font-size: 16px;
    line-height: 24px;
    color: #353744;
  }

  p {
    font-weight: 400;
    font-size: 12px;
    line-height: 18px;
    color: #65666A;
    margin: 8px 0 32px;
  }

  button {
    padding: 6px 0;
  }
`

export const QuoteLimitsTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  thead {
    tr {
      th { 
        color: #7B7C82;
        font-weight: 900;
        padding: 24px 0 0;
        width: 25%;
      }
    }
  }
  tbody {
    tr {
      td {
        border: 0;
        background: #fff;
        color: #353744;
        font-weight: 800;
        font-size: 16px;
        line-height: 21px;
        padding: 24px 0 0px;
        text-align: left;    
      }  
    }
  }
`


export const PolicyTableContainer = styled.div`
  width: 100%;

  h6 {
    font-size: 16px;
    line-height: 24px;
    color: #65666A;
    margin-bottom: 8px;
  }
`

export const PolicyTableHeader = styled.table`
  width: 100%;
  border-collapse: collapse;

  td {
    border: 0.5px solid #C8C8C8;
    background: #fff;
    font-weight: 400;
    font-size: 14px;
    line-height: 21px;
    padding: 24px 0 24px 32px;

    &:first-of-type{
      font-weight: 800;
      width: 30%;
      padding: 0;
    }

    &:last-of-type {
      width: 35%;
    }
  }

  @media only screen and (max-width: 640px) {
    display: block;

    tr {
      display: block;

      td {
        display: block;
        width: 100%;
        padding: 12px 20px;

        &:first-of-type {
          padding: 12px 20px;
          width: 100%;
        }

        &:last-of-type {
          width: 100%;
        }
      }
    }
  }
`

export const PolicyTable = styled.table`
  width: 100%;
  border-collapse: collapse;

  td {
    border: 0.5px solid #C8C8C8;
    background: #fff;
    font-weight: 400;
    font-size: 14px;
    line-height: 21px;
    padding: 24px 0 24px 32px;

    &:first-of-type{
      font-weight: 800;
      width: 30%;
    }

    &:last-of-type {
      width: 35%;
    }
  }

  & .coverage-included {
    display: flex;
    align-items: center;
    gap: 5px;
    
    & div {
      margin: 0;
      min-width: 16px;
      min-height: 16px;
      width: 16px;
      height: 16px;
    }

    & svg {
      width: 10px;
      height: 10px;
      stroke-width: 2;
    }
  }

  @media only screen and (max-width: 640px) {
    td {
      border: 0.5px solid #C8C8C8;
      background: #fff;
      font-weight: 400;
      font-size: 14px;
      line-height: 21px;
      padding: 12px;
      width: 33.3% !important;
    }

    & .coverage-included {
      flex-direction: column;
      text-align: center;
    }
  }
`

export const PolicyImageContainer = styled.div`
  border-radius: 50%;
  height: 120px;
  width: 120px;
  min-width: 120px;
  background-color: #F5F9F9;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: auto;

  & img {
    width: 62px;
    height: 62px;
  }
`

export const GreenContainer = styled.div`
  width: 100%;
  background: #3D6666;
  border: 2px solid #3D6666;
  padding-top: 32px;

  & + & {
    margin-top: 64px;
  }

  & div.green-container-content {
    width: 100%;
    height: 100%;
    background: #F5F9F9;
    padding: 32px 44px;
    display: flex;
    flex-direction: column;

    & h6 {
      font-weight: 900;
      font-size: 16px;
      line-height: 24px;
      color: #54565F;
    }

    & span {
      font-weight: 400;
      font-size: 14px;
      line-height: 21px;
      color: #7B7C82;
      margin: 8px 0 32px;
    }

    & > div {
      width: 100%;
      height: 100%;
      display: flex;
      gap: 24px;
    }
  }

  & .claim-all-set {
    background: #fff;
    display: flex;
    gap: 24px;
    padding: 24px;

    & .claim-all-set-icon {
      display: flex;
      align-items: center;
      justify-content: center;
      background: #F5F9F9;
      border-radius: 50%;
      min-width: 90px;
      min-height: 90px;

      img {
        width: 47.25px;
        height: 44.55px;
      }
    }

    & .claim-all-set-message {
      display: flex;
      flex-direction: column;
      justify-content: center;

      h3 {
        font-weight: 900;
        font-size: 24px;
        line-height: 34px;
        color: #3D6666;
      }

      h4 {
        font-weight: 400;
        font-size: 16px;
        line-height: 24px;
        color: #65666A;
      }
    }
  }
`

export const GreenContainerQuestionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;

  & .green-container-question-div {
    display: flex;
    gap: 12px;

    & > div {
      margin: 0;
    }

    p {
      font-weight: 900;
      font-size: 18px;
      line-height: 24px;
      color: #353744;
    }
  }
`

export const ClaimsContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  margin-top: 42px;

  .claims-form-header-subtitle {
    font-weight: 900;
    font-size: 18px;
    line-height: 24px;
    color: #353744;
  }

  .claims-form-header-instruction {
    font-weight: 900;
    font-size: 16px;
    line-height: 24px;
    color: #7B7C82;
  }

  .claims-add-button {
    margin-top: 160px;
    max-width: 320px;

    button {
      width: 100%;
    }
  }
`

export const SectionCompleteImageContainer = styled.div`
  border-radius: 50%;
  height: 360px;
  width: 360px;
  min-width: 120px;
  background-color: #F5F9F9;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: auto;
  margin: 50px auto;

  & img {
    width: 200px;
    height: 200px;
  }
`

export const ReviewCardContainer = styled.div`
  width: 100%;
  height: 100%;
  background-color: #fff;
  padding: 36px 48px;
  border: 1px solid #C8C8C8;

  @media only screen and (max-width: 640px) {
    padding: 24px;
  }

  header {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 2px solid #EFEFEF;
    padding-bottom: 18px;

    div {
      display: flex;
      align-items: center;
    }

    @media only screen and (max-width: 640px) {
      flex-direction: column;

      & > div {
        width: 100%;
        justify-content: space-between;
      }

      button {
        margin-top: 10px;
        width: 100%;
      }
    }

    h4 {
      font-weight: 900;
      font-size: 24px;
      line-height: 34px;
      color: #353744;
    }

    h6 {
      font-weight: 800;
      font-size: 12px;
      line-height: 18px;
      color: #3D6666;
      margin-left: 14px;
      display: flex;
      align-items: center;
      gap: 4px;
    }
  }

  h5 {
    font-weight: 900;
    font-size: 16px;
    line-height: 24px;
    color: #7B7C82;
    margin-bottom: 24px;
  }
  
  main {
    display: grid;
    grid-template-columns: 50% 50%;
    width: 100%;
    gap: 24px;
    margin-top: 32px;

    @media only screen and (max-width: 640px) {
      grid-template-columns: 100%;
    }

    div.column {
      width: 100%;
      display: flex;
      flex-direction: column;
      gap: 36px;
    }

    section {
      width: 100%;
      margin-top: 0;
    }

    article + h5 {
      margin-top: 48px;
    }

    article {
      display: flex;
      flex-direction: column;

      strong {
        font-weight: 900;
        font-size: 14px;
        line-height: 21px;
        color: #353744;
      }

      span {
        font-weight: 400;
        font-size: 14px;
        line-height: 21px;
        color: #65666A;
        display: flex;
        flex-direction: column;
        gap: 4px;

        h6 {
          font-weight: 800;
          font-size: 14px;
          line-height: 21px;
          color: #65666A;
        }
      }

      table {
        margin-top: -12px;
        border-collapse: separate;
        border-spacing: 0 16px;
      }

      td:first-of-type {
        font-weight: 900;
      }
    }

    article + article {
      margin-top: 32px;
    }
  }

  main.attorneys {
    display: flex;
    flex-wrap: wrap;
    gap: 24px;

    h5 {
      width: 100%;
      margin: 0;
    }

    article {
      width: calc(50% - 12px);
      margin-top: 0;
    }

    @media only screen and (max-width: 640px) {
      flex-direction: column;

      article {
        width: 100%;
      }
    }
  }

  footer {
    width: 100%;
    margin-top: 64px;

    .review-footer-button-container {
      max-width: 300px;
      margin-top: 26px;

      button {
        padding: 8px 0;
        width: 100%;
        max-width: 300px;
      }
    }

    .review-footer-note-container {
      display: flex;
      flex-direction: column;
      gap: 24px;

      button {
        padding: 8px 0;
        width: 100%;
        max-width: 300px;
      }

      .review-footer-note-buttons {
        display: flex;
        gap: 24px;
      }
    }

    .review-footer-filepicker-container {
      margin-top: 26px;
    }

    button.review-button-small-width {
      max-width: 220px;
    }
  }
`

export const SuccessInputTextHelper = styled.small`
  color: #059162;
  font-weight: 400;
  font-size: 14px;
  line-height: 21px;
  display: flex;
  align-items: center;
  gap: 8px;

  svg {
    width: 16px;
    height: 16px;
  }
`

export const OnboardingNewApplicationFirmAdminCheckboxContainer = styled.div<{ isJudge?: boolean }>`
  width: 100%;

  .tlie__standard_checkbox_container {
    align-items: ${props => props.isJudge ? 'flex-start' : 'center'}
  }
`

export const ButtonWithMessageContainer = styled.div`
  position: relative;
  
  @media only screen and (max-width: 640px) {
    width: 100%;
  }

  & .savelater_message_container {
    position: absolute;
    bottom: 100px;
    transition: 0.5s;

    display: grid;
    grid-template-columns: 64px 380px;
    gap: 16px;

    border: 1px solid #C8C8C8;
    padding: 24px;
    background: #FFFFFF;

    div {
      display: flex;
      flex-direction: column;
      justify-content: center;
    }

    & div:first-child {
      background: #EBF2F2;
      border-radius: 50%;
      min-width: 64px;
      min-height: 64px;
      max-width: 64px;
      max-height: 64px;
      align-items: center;
      margin: auto 0;

      img {
        width: 24px;
      }
    }

    & div:last-child {
      gap: 18px;

      h5 {
        color: #937251;
        font-weight: 800;
        font-size: 14px;
        line-height: 21px;
      }

      p {
        color: #52545D;
        font-weight: 400;
        font-size: 14px;
        line-height: 21px;
      }
    }
  }

  .savelater_message_container.open-container {
    left: 0;
  }

  .savelater_message_container.close-container {
    left: 100vw;
  }

  .savelater_message_container.content-hidden {
    width: 0;
    padding: 0;
    border: 0;

    div {
      display: none;
    }
  }
`

export const JudgeQuoteContainer = styled.div`
  background-color: #fff;
  display: flex;
  flex-direction: column;
  padding: 24px 32px;
  gap: 24px;
  border: 1px solid #C8C8C8;

  h5 {
    font-weight: 800;
    font-size: 16px;
    line-height: 24px;
    color: #353744;
  }

  p {
    font-weight: 400;
    font-size: 14px;
    line-height: 21px;
    color: #353744;
  }
`